export const products = {
  hero: {
    title: 'Three Product Lines',
    subtitle: 'Covering All Light Wellness Scenarios',
    description: 'From pocket-sized micro-labs to nature-restoring black tech, to neo-Chinese punk wellness. ShanDouDou uses a three-product matrix to provide scientific solutions for health needs in different scenarios.',
  },
  tracks: [
    {
      name: 'Functional Gummies & Gel Candies',
      tagline: 'Pocket-Sized Micro Lab',
      description: 'The most accessible form of light wellness for young people. Using microencapsulation technology to wrap active ingredients, solving the bitter taste problem of traditional Chinese medicine. Zero sugar, zero fat, natural erythritol sweetener.',
      features: ['Microencapsulation Technology', 'Zero Sugar / Zero Fat Formula', 'Natural Erythritol Sweetener', 'Mini Aluminum Foil Packs'],
      products: [
        {
          name: 'Late-Night Rescue Gummies',
          tag: 'Liver & Eyes',
          ingredients: ['Ginseng Extract', 'Kudzu Extract', 'Chrysanthemum Extract'],
          target: 'Overtime workers, night owls',
        },
        {
          name: 'Whitening Antioxidant Pearls',
          tag: 'Vitamin C Brightening',
          ingredients: ['Cili Fruit Extract', 'Rose Extract', 'Sea Buckthorn Extract'],
          target: 'Those seeking whitening & antioxidant',
        },
        {
          name: 'Sleep Aid Gummies',
          tag: 'GABA Sleep Support',
          ingredients: ['Sour Jujube Seed', 'GABA', 'Lavender Extract'],
          target: 'People with insomnia & anxiety',
        },
      ],
    },
    {
      name: 'Freeze-Dried Ready-to-Eat Tonics',
      tagline: 'Black Tech That Restores Nature',
      description: 'FD freeze-drying technology locks in 98%+ of nutrients, making it the preferred process for premium health foods. What used to take 4 hours of stewing now takes 60 seconds with hot water.',
      features: ['FD Freeze-Drying 98%+', 'Clean Label, No Preservatives', '60-Second Ready', 'Low-Temp Breaking for Easy Absorption'],
      products: [
        {
          name: 'Freeze-Dried Tremella / Bird\'s Nest Soup',
          tag: 'Full Collagen',
          ingredients: ['Gutian Tremella', 'Bird\'s Nest', 'Red Dates', 'Goji Berries'],
          target: 'Beauty & skin care, lung nourishment',
        },
        {
          name: 'Freeze-Dried Fruit Chips',
          tag: 'Medicinal Food',
          ingredients: ['Fig', 'Yellow Peach', 'Mulberry'],
          target: 'Office snacks, healthy cravings',
        },
        {
          name: 'Probiotic Freeze-Dried Powder',
          tag: 'Gut Health',
          ingredients: ['Composite Probiotics', 'Dietary Fiber', 'Fructooligosaccharides'],
          target: 'Sedentary constipation, gut health',
        },
      ],
    },
    {
      name: 'Chinese Herbal Energy Bars / Baking',
      tagline: 'Neo-Chinese Punk Wellness',
      description: 'Transforming traditional heavy-flavor wellness ingredients into snack-friendly formats for meal replacement and afternoon tea scenarios. Calorie-control technology precisely calculates the calories in every bar.',
      features: ['Precise Calorie Control', 'Enzymatic Bean Odor Removal', 'Individual Packaging', 'Medicinal Food Ingredients'],
      products: [
        {
          name: 'Black Sesame Balls Pro',
          tag: 'Nourish Black with Black',
          ingredients: ['Black Sesame', 'DHA Algae Oil', 'Probiotics'],
          target: 'Hair loss prevention, hair care',
        },
        {
          name: 'Tangerine Red Bean / Poria Yam Cake',
          tag: 'Spleen & Dampness',
          ingredients: ['Xinhui Tangerine Peel', 'Red Bean', 'Poria', 'Yam'],
          target: 'Dampness-heavy, easily fatigued people',
        },
        {
          name: 'High-Protein Plant Jerky',
          tag: 'Low-Carbon Eco',
          ingredients: ['Soy Protein', 'Pea Protein', 'Shiitake Extract'],
          target: 'Weight-loss crowd, vegetarians',
        },
      ],
    },
  ],
};